import { unstable_httpBatchStreamLink } from '@trpc/client';
import { createTRPCReact } from '@trpc/react-query';
import { SuperJSON } from 'superjson';

import { TRPCRouter } from '~/api/routes';

export const api = createTRPCReact<TRPCRouter>();

export const trpcClient = api.createClient({
  links: [unstable_httpBatchStreamLink({ url: '/api/trpc', transformer: SuperJSON })],
});

export const TRPCProvider = api.Provider;
